var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-loader",attrs:{"id":"loading"}},[_c('h2',{staticClass:"text-white"},[_vm._v("Espere ...")])])
}]

export { render, staticRenderFns }